var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgShieldSearch1 = function SvgShieldSearch1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shield-search-1_svg__shield-search-1_svg__clip0_4746_14269)",
    stroke: "#48525C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14A8 8 0 012.334 4 8 8 0 008 2a8 8 0 005.667 2 7.994 7.994 0 01.188 3.725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12a2 2 0 104 0 2 2 0 00-4 0zm3.467 1.467l1.2 1.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shield-search-1_svg__shield-search-1_svg__clip0_4746_14269"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgShieldSearch1;